export const APPOINTMENT_STATUS = {
  confirmed: { label: "Onaylandı", dot: "bg-emerald-500", card: "bg-emerald-50 border-emerald-200 text-emerald-900", cardDark: "bg-emerald-500/15 border-emerald-500/30 text-emerald-100" },
  waiting: { label: "Bekliyor", dot: "bg-sky-500", card: "bg-sky-50 border-sky-200 text-sky-900", cardDark: "bg-sky-500/15 border-sky-500/30 text-sky-100" },
  examination: { label: "Muayene", dot: "bg-amber-500", card: "bg-amber-50 border-amber-200 text-amber-900", cardDark: "bg-amber-500/15 border-amber-500/30 text-amber-100" },
  urgent: { label: "Acil", dot: "bg-rose-500", card: "bg-rose-50 border-rose-200 text-rose-900", cardDark: "bg-rose-500/15 border-rose-500/30 text-rose-100" },
  completed: { label: "Tamamlandı", dot: "bg-violet-500", card: "bg-violet-50 border-violet-200 text-violet-900", cardDark: "bg-violet-500/15 border-violet-500/30 text-violet-100" },
  cancelled: { label: "İptal", dot: "bg-slate-400", card: "bg-slate-100 border-slate-300 text-slate-700", cardDark: "bg-slate-700/40 border-slate-600/40 text-slate-300" },
  leave: { label: "İzin/Tatil", dot: "bg-orange-500", card: "bg-orange-50 border-orange-200 text-orange-900", cardDark: "bg-orange-500/15 border-orange-500/30 text-orange-100" },
  other: { label: "Diğer", dot: "bg-gray-400", card: "bg-gray-50 border-gray-200 text-gray-800", cardDark: "bg-gray-700/30 border-gray-600/40 text-gray-200" },
};

export const DAY_START_HOUR = 8;
export const DAY_END_HOUR = 20;
export const HOUR_HEIGHT = 56;
export const SYNC_INTERVAL_MS = 10 * 60 * 1000;

export const timeToMinutes = (time) => {
  const [h, m] = String(time || "00:00").split(":").map(Number);
  return h * 60 + m;
};

export const minutesToTime = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

export const formatDisplayDate = (date) =>
  date.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", weekday: "long" });

export const formatShortDate = (date) =>
  date.toLocaleDateString("tr-TR", { day: "numeric", month: "short" });

export const formatWeekdayShort = (date) =>
  date.toLocaleDateString("tr-TR", { weekday: "short" });

export const toYmd = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const startOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const daysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

export const getViewRange = (viewMode, selectedDate) => {
  if (viewMode === "week") {
    const start = startOfWeek(selectedDate);
    const end = addDays(start, 6);
    return { start, end, startYmd: toYmd(start), endYmd: toYmd(end) };
  }
  if (viewMode === "month") {
    const start = startOfMonth(selectedDate);
    const end = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
    return { start, end, startYmd: toYmd(start), endYmd: toYmd(end) };
  }
  const ymd = toYmd(selectedDate);
  return { start: selectedDate, end: selectedDate, startYmd: ymd, endYmd: ymd };
};

export const snapMinutes = (mins, step = 15) => Math.round(mins / step) * step;

export const buildDateTime = (date, time) => `${toYmd(date)} ${time}:00`;
